import React from 'react';
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip,
  Tooltip,
  IconButton
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useHistory } from 'react-router-dom';
import useStyles from '../../styles';
import { basicDate, parseISO } from '../../../../utils/dateFormatter';
import { toCurrency } from '../../../../utils/mask';

const states = {
  Pago: 'success',
  Pendente: 'warning',
  Baixa: 'secondary',
  Vencido: 'secondary',
};

export default function TableComponent({ data }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Table className="mb-0">
      <TableHead>
        <TableRow>
          <TableCell>Cliente</TableCell>
          <TableCell>Valor</TableCell>
          <TableCell>Vencimento</TableCell>
          <TableCell>Código do banco</TableCell>
          <TableCell>Estado</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>

      <TableBody>
        {data.length === 0 && (
          <TableRow>
            <TableCell>Sem registros</TableCell>
          </TableRow>
        )}
        {data.length > 0 && data.map(({
          Cliente,
          valor,
          vencimento,
          banco_inter: banco,
          EstadosFatura,
          Cobranca,
          id_fatura: fatura
        }) => (
          <TableRow key={fatura}>
            <TableCell className="pl-3 fw-normal">{Cliente.nome}</TableCell>
            <TableCell>{toCurrency(valor, true)}</TableCell>
            <TableCell>{basicDate(parseISO(vencimento))}</TableCell>
            <TableCell>{banco}</TableCell>
            <TableCell>
              <Chip label={EstadosFatura.nome} classes={{ root: classes[states[EstadosFatura.nome]] }} />
            </TableCell>
            <TableCell>
              <Tooltip title="Detalhes" aria-label="detalhes">
                <IconButton
                  color="warning"
                  aria-label="detalhes"
                  onClick={() => {
                    history.push(`/app/cobrancas/${Cobranca.id_cobranca}`);
                  }}
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
